export enum AuthRoutes {
  profile = "/profile",
  companies = "/companies",
  municipalities = "/municipalities",
  createMunicipality = "/municipalities/new",
  students = "/students",
  studentApplications = "/student-applications",
  studentAgreements = "/student-agreements",
  schools = "/schools",
  guide = "/guide",
  applications = "/applications",
  statistics = "/statistics",
  myPositions = "/myPositions",
  excursions = "/excursions",
  myExcursions = "/myExcursions",
  myInternships = "/myInternships",
  myCompetencies = "/myCompetencies",
  municipalityContent = "/municipalityContent",
  schoolContent = "/schoolContent",
  reports = "/reports",
  seasons = "/seasons",
  users = "/users",
}

export enum NonAuthRoutes {
  home = "/",
  about = "/about",
  login = "/login",
  passwordRecovery = "/passwordRecovery",
  passwordRecoveryConfirmation = "/reset",
  registration = "/registration",
  shadowings = "/shadowings",
  companyDetails = "/companies/:id",
  privacyPolicy = "/privacy",
  fillReflections = "/fill-reflections/:applicationId",
  openFeedback = "/open-feedback/:shadowingId",
  organisations = "/organisations",
  internships = "/internships",
}
